// extracted by mini-css-extract-plugin
module.exports = {"svg":"IconButton_svg_uNpHQ"};